import { useState } from "react";
import { useUiContext } from "@rotorstudios/fe-ui";

import useGA from "../../modules/fe-modules/GA/useGA";
import useUrlParamLinks from "../../modules/Data/useUrlParamLinks";
import { GaEvent } from "../../modules/fe-modules/GA/static";
import { isDesktopUserAgent } from "../../helpers/utils";

export type UseUiMButtonARProps = {
  gaProps?: {
    eventId?: string;
    buttonName?: string;
    viewName: string;
    viewSection: string;
  };
};

const useUiMButtonAR = ({ gaProps }: UseUiMButtonARProps) => {
  const { triggerGAEvent } = useGA();
  const { projectClass, breakpointActive } = useUiContext();
  const { createIntentUrlLink } = useUrlParamLinks();
  const [isOpenQRCodeOverlay, setIsOpenQRCodeOverlay] = useState<boolean>(false);
  const [isOpenQRCodeLinkOverlay, setIsOpenQRCodeLinkOverlay] = useState<boolean>(false);
  const [isOpenARUnavailableOverlay, setIsOpenARUnavailableOverlay] =
    useState<boolean>(false);

  const onClickARHandler = () => {
    isDesktopUserAgent()
      ? setIsOpenQRCodeOverlay(true)
      : setIsOpenQRCodeLinkOverlay(true);

    triggerGAEvent(GaEvent.LAUNCH_AR, {
      ...gaProps,
    });
  };

  return {
    projectClass,
    breakpointActive,
    arUrlLink: createIntentUrlLink(),
    isOpenQRCodeOverlay,
    isOpenQRCodeLinkOverlay,
    isOpenARUnavailableOverlay,
    onClickARHandler,
    setIsOpenQRCodeOverlay,
    setIsOpenQRCodeLinkOverlay,
    setIsOpenARUnavailableOverlay,
  };
};

export default useUiMButtonAR;
